module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HKFnZ8/tc-custom/9781937384289.jpg?1725275550951",
      "alt": "This image is the cover for the book Artists in Crime, Roderick Alleyn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Artists in Crime, Roderick Alleyn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A model is murdered in this “first-rate” detective story by the Mystery Writers of America Grand Master ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" On a ship traveling back to England, Miss Agatha Troy finds Inspector Roderick Alleyn tedious and dull; he thinks she’s a bohemian cliché. They may be destined for romance, but there’s a murder in the way: No sooner has Alleyn settled in to his mother’s house, eager for a relaxing end to his vacation, than he gets a call that a model has been stabbed at the artists’ community down the road. And the talented Miss Troy is one of the community’s most prominent and outspoken members . . ."), _c('br'), _c('br'), _vm._v(" “The doyenne of traditional mystery writers.” —"), _c('i', [_vm._v("The New York Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ngaio Marsh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dame Ngaio Marsh was one of the celebrated queens of the Golden Age of detective fiction. The Roderick Alleyn series was successfully adapted for television and was quite popular both in the U.K. and the United States. "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0